import { render, staticRenderFns } from "./ProfileAcademicTrainingList.vue?vue&type=template&id=4e11e98d"
import script from "./ProfileAcademicTrainingList.vue?vue&type=script&lang=js"
export * from "./ProfileAcademicTrainingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports